import React from "react";

import "./BaseDatePicker.css";

const BaseDatePicker = (props) => {
  const convertToDateTimeString = (v) =>
    Date.parse(v)
      ? `${v.getFullYear()}-${("0" + (v.getMonth() + 1)).slice(-2)}-${(
          "0" + v.getDate()
        ).slice(-2)}T${("0" + v.getHours()).slice(-2)}:${(
          "0" + v.getMinutes()
        ).slice(-2)}`
      : "";

  return (
    <input
      type="datetime-local"
      name={props.name}
      className={props.className + " cl-base-date-time-picker"}
      onChange={(ev) => props.onChange(new Date(Date.parse(ev.target.value)))}
      value={convertToDateTimeString(props.value)}
      min={props.min ? convertToDateTimeString(props.min) : ""}
      disabled={props.disabled}
      required
    />
  );
};

export default BaseDatePicker;
